import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import currentUserReducer from '../features/currentUserSlice';
import loadingMessageReducer from '../features/loadingMessageSlice';

export const store = configureStore({
  reducer: {
    currentUser: currentUserReducer,
    loadingMessage: loadingMessageReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
